import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useId } from 'react';
import classNames from 'classnames';
import { RadioGroup } from './Radio.Group/Radio.Group.es.js';
import { useRadioGroupContext } from './Radio.Group.Context/index.es.js';

const Radio = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { children, value, checked, disabled, name, className, helpText, error, onChange, ...rest } = props;
    // If RadioGroup Context.Provider is present, derive props based on the
    // Provider wrapper props; otherwise, return original props as-is.
    const context = useRadioGroupContext({
        checked,
        disabled,
        name,
        onChange,
        value
    });
    // Define radio id to bind label and input with `htmlFor`
    const radioId = useId();
    // Define help text id to bind help text and input with `aria-describedby`
    const helpTextId = useId();
    return jsxs("div", {
        className: classNames('cb-radio', {
            disabled: context.disabled
        }),
        "data-testid": "radio",
        children: [
            jsxs("div", {
                className: "radio-button-label",
                children: [
                    jsxs("div", {
                        className: "radio-button",
                        children: [
                            jsx("input", {
                                ref: ref,
                                checked: context.checked,
                                className: classNames('radio-input', {
                                    error
                                }, className),
                                disabled: context.disabled,
                                id: radioId,
                                name: context.name,
                                onChange: context.onChange,
                                type: "radio",
                                value: value,
                                ...helpText != null && {
                                    'aria-describedby': helpTextId
                                },
                                ...rest
                            }),
                            jsx("span", {
                                className: "selected-indicator"
                            })
                        ]
                    }),
                    children != null && jsx("label", {
                        className: "label",
                        "data-testid": "label",
                        htmlFor: radioId,
                        children: children
                    })
                ]
            }),
            helpText != null && jsx("p", {
                className: "help-text",
                "data-testid": "help-text",
                id: helpTextId,
                children: helpText
            })
        ]
    });
});
Radio.displayName = 'Radio';
const RadioNamespace = Radio;
RadioNamespace.Group = RadioGroup;

export { RadioNamespace as Radio, RadioNamespace as default };
//# sourceMappingURL=Radio.es.js.map
